const styles = {
  historyBoxWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ChangeHistoryBox/ChangeHistoryBox.styles.js